import { put, call, take, fork } from 'redux-saga/effects'
import { AICreatorDeleteAttachmentService } from '../../api/ai-creator'
import { aICreatorDeleteAttachmentSuccess } from '../../reducers/ai-creator/action'
import { DELETE_ATTACHMENT } from '../../reducers/ai-creator/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* deleteAttachmentFlow(payload) {
  try {
    const { attachmentId, callback } = payload

    /* const response = yield call(
      AICreatorDeleteAttachmentService,
      attachmentId,
    ) */

    yield put(aICreatorDeleteAttachmentSuccess(attachmentId))
    yield put(operationSuccess())
    callback(attachmentId)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* aICreatorDeleteAttachmentWatcher() {
  while (true) {
    const action = yield take(DELETE_ATTACHMENT)
    const { payload } = action

    yield fork(generalSaga, deleteAttachmentFlow, payload, false)
  }
}
